/*
 * @Author: Ning
 * @Date: ****** 13:23:08
 * @LastEditTime: 2020-09-09 14:38:05
 * @LastEditors: Ning
 * @Description: System Logs 日志
 * @Do not edit
 */
import { createStore, applyMiddleware } from "redux";
import rootReducer from './reducers';
import thunkMiddleware from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
const persistConfig = {
    key: 'root',
    storage: storageSession,
    whitelist: [],
    stateReconciler: autoMergeLevel2
};
const myPersistReducer = persistReducer(persistConfig, rootReducer);
const store = createStore(myPersistReducer, applyMiddleware(thunkMiddleware))
export const persistor = persistStore(store);
export default store;
